<template>
  <div>
    <v-text-field
      :placeholder="placeholder"
      :value="value"
      append-icon="search"
      clearable
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'KeywordFilter',
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '検索',
    },
  },
}
</script>
